export const capitalize = (word) => {
  if (!word) {
    return word;
  }

  if (word.length < 2) {
    return word.toUpperCase();
  }
  else {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
}


export const camelCase = (text) => {
  if (!text) {
    return text;
  }

  const words = text.split(/[._:-]/);
  return words.map(word => capitalize(word)).join(' ');
}


/**
 * Replaces single quote ( ' ) with special valid one to save in json ( ` )
 * TODO: 
 *  Consider replacing also /, "value", etc..
 */
export const reformat = (str) => {
  if (str) {
    return str.replace("'", "’");
  }
  else {
    return str;
  }
}

export default function useMyStrings() {
  return {
  }
}
